module.exports = __webpack_public_path__ + "static/media/patreonLogo.499b059d.svg";